import React, { useState } from "react";
import Modal from "./Modal";
import InputField from "../fields/InputField";
import DropdownField from "../fields/DropdownField";
import { open_api_with_cookies } from "../../Utils/network";
import "./PayoutModal.css";
import { formatDateTime } from "../../Utils/helper";
import Button from "../Button/Button";
const PayoutModal = ({ payout, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    expert: payout.expert || "",
    account_number: payout.account_number || "",
    reference_number: payout.reference_number || "",
    fund_transfer_type: payout.fund_transfer_type || "",
    payout_date: payout.payout_date || new Date(),
    payout_status: payout.payout_status || "1", // Default to pending (1)
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDropdownChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value === "Paid" ? "2" : "1",
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await open_api_with_cookies.put(
        `/dashboard/payout/update/${payout.id}/`,
        {
          ...formData,
          payout_date: formData.payout_date,
        }
      );

      if (response.status === 200) {
        onSuccess();
        onClose();
      } else {
        setError(response.data.message || "Failed to update payout");
      }
    } catch (error) {
      setError(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title="Update Payout Details" onClose={onClose}>
      <div className="payout-modal-content">
        {/* Read-only fields */}
        <InputField
          label="Expert Name"
          value={payout.expert_name || "-"}
          readOnly={true}
        />
        <InputField
          label="Paid By"
          value={"Myburgo admin" || "-"}
          readOnly={true}
        />
        <InputField
          label="Billed Date"
          value={
            formatDateTime(payout.billed_date).formattedDate +
            " " +
            formatDateTime(payout.billed_date).formattedTime
          }
          readOnly={true}
        />
        <InputField
          label="Amount Paid (₹)"
          value={payout.amount?.toLocaleString() || "0"}
          readOnly={true}
        />

        {/* Editable fields */}
        <InputField
          label="Account Number"
          name="account_number"
          value={formData.account_number}
          onChange={handleInputChange}
        />

        <InputField
          label="Reference Number"
          name="reference_number"
          value={formData.reference_number}
          onChange={handleInputChange}
        />

        <InputField
          label="Fund Transfer Type"
          name="fund_transfer_type"
          value={formData.fund_transfer_type}
          onChange={handleInputChange}
        />

        <DropdownField
          label="Payout Status"
          options={["Pending", "Paid"]}
          value={formData.payout_status === "2" ? "Paid" : "Pending"}
          onChange={(value) => handleDropdownChange("payout_status", value)}
        />

        {error && <div className="error-message">{error}</div>}

        <div className="payout-modal-actions">
          <Button
            text={loading ? "Saving..." : "Save Changes"}
            onClick={handleSubmit}
            disabled={loading}
          ></Button>
        </div>
      </div>
    </Modal>
  );
};

export default PayoutModal;
